/**
 * this files contains all routes including the names and the links
 *
 *
 * Created by Tom on 23/05/18
 */

import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router'
import { withRouter, Switch } from 'react-router-dom'

import Funds from './pages/Funds/'
import Fund from './components/Fund/'
import FundAdd from './components/FundAdd/'
import Account from './pages/Account'
import Documents from './pages/Documents'
import Billing from './pages/Billing'

const Routes = (props) => {
	
    return (
        <Switch>
            <Route exact path="/" component={Funds} />
            <Route exact path="/fund/:member_id" component={Fund} />
            <Route exact path="/create_fund" component={FundAdd} />
            <Route exact path="/resume_fund/:member_id" component={FundAdd} />
            <Route exact path="/transition_fund" component={FundAdd} />
            <Route exact path="/documents" component={Documents} />
        </Switch>
    )
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        //isAuthenticated: state.user.isAuthenticated
    }
}

export default withRouter(connect(mapStateToProps)(Routes))



// WEBPACK FOOTER //
// ./src/routes.js